/**
 * Newest-first comparator for rows carrying a `created_at` timestamp.
 *
 * Plain `<`/`>` rather than `localeCompare`: PostgREST emits mixed fractional
 * precision on the same column ("…:29.736+00:00" next to "…:34.580565+00:00",
 * and a whole second has no fraction at all), and ICU collation down-weights
 * punctuation — so `localeCompare` orders the EARLIER of two same-second rows
 * first. That decides which archive row wins the archived-vs-lapsed split, so
 * it is not purely cosmetic. Codepoint comparison is correct for any ISO-8601
 * string and locale-independent.
 *
 * Missing/null timestamps sort last.
 */
export function byCreatedAtDesc(
  a: { created_at?: string | null },
  b: { created_at?: string | null },
): number {
  const av = a.created_at ?? '';
  const bv = b.created_at ?? '';
  if (av === bv) return 0;
  return bv > av ? 1 : -1;
}
